import { OgResult } from "@/shared/types";

export interface Props {
  metadata: OgResult;
}

const FeedOgContent = ({ metadata }: Props) => {
  return (
    <a
      href={metadata.link}
      className="w-full flex flex-col mb-6 border border-opacityGray-300"
    >
      <img src={metadata.image} alt={metadata.title} />
      <div className="p-4">
        <h4 className={metadata.description && "mb-2"}>{metadata.title}</h4>
        <p className="text-body-4 leading-5">{metadata.description}</p>
      </div>
    </a>
  );
};

export default FeedOgContent;
